// src/pages/Carrito.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useShopify } from "../context/StoreContext";
import { ECUADOR } from "../config/ecuador";
import "./Checkout.css";
import { Modal, Button } from "react-bootstrap";
import "./Carrito.css";
import { buildWhatsAppUrl } from "../config/store";

const Carrito = () => {
  const navigate = useNavigate();
  const {
    cartItems,
    getCartTotal,
    clearCart,
    removeFromCart,
    updateQuantity,
    submitOrder,
  } = useShopify();

  const [loading, setLoading] = useState(false);
  const [pedidoExitoso, setPedidoExitoso] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [ordenGuardada, setOrdenGuardada] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    email: "",
    direccion: "",
    referencia: "",
    provincia: "",
    ciudad: "",
    notas: "",
  });

  const ciudadesDisponibles = formData.provincia
    ? ECUADOR.find((p) => p.provincia === formData.provincia)?.ciudades || []
    : [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "provincia") {
      setFormData((prev) => ({ ...prev, provincia: value, ciudad: "" }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (errors[name]) {
      setErrors((prev) => {
        const n = { ...prev };
        delete n[name];
        return n;
      });
    }
  };

  const validarFormulario = () => {
    const e = {};
    if (!formData.nombre.trim()) e.nombre = "El nombre es obligatorio.";
    if (!formData.apellido.trim()) e.apellido = "El apellido es obligatorio.";
    if (!formData.telefono.trim() || formData.telefono.length < 9)
      e.telefono = "Ingresa un teléfono válido (mínimo 9 dígitos).";
    if (!formData.direccion.trim())
      e.direccion = "La dirección es obligatoria.";
    if (!formData.provincia) e.provincia = "Selecciona tu provincia.";
    if (!formData.ciudad) e.ciudad = "Selecciona tu ciudad.";
    setErrors(e);
    return e;
  };

  const generarLinkWhatsApp = (orden) => {
    const productos = orden.productos
      .map(
        (p) =>
          `• ${p.nombre} x${p.cantidad} — $${(p.precio * p.cantidad).toFixed(2)}`,
      )
      .join("\n");

    const mensaje = `🛒 *NUEVO PEDIDO — ROMI STORE EC*
━━━━━━━━━━━━━━━━━━━━
📦 Orden #${orden.orderId}
━━━━━━━━━━━━━━━━━━━━
👤 *Cliente:* ${orden.cliente.name} ${orden.cliente.surname}
📱 *Teléfono:* ${orden.cliente.phone}
📍 *Ciudad:* ${orden.cliente.ciudad}, ${orden.cliente.provincia}
🏠 *Dirección:* ${orden.cliente.address}${orden.cliente.notes ? "\n📝 *Notas:* " + orden.cliente.notes : ""}
━━━━━━━━━━━━━━━━━━━━
🛍️ *PRODUCTOS:*
${productos}
━━━━━━━━━━━━━━━━━━━━
💵 *TOTAL: $${orden.total.toFixed(2)} USD*
🚚 Envío: GRATIS
💳 Pago: Contra entrega`;

    return buildWhatsAppUrl(mensaje);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validarFormulario();
    if (Object.keys(validationErrors).length > 0) {
      const firstKey = Object.keys(validationErrors)[0];
      document
        .querySelector(`[name="${firstKey}"]`)
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setLoading(true);
    try {
      const provinciaObj = ECUADOR.find(
        (p) => p.provincia === formData.provincia,
      );
      const customerData = {
        name: formData.nombre,
        surname: formData.apellido,
        phone: formData.telefono,
        email: formData.email,
        address: `${formData.direccion}${formData.referencia ? " — Ref: " + formData.referencia : ""}`,
        ciudad: formData.ciudad,
        provincia: formData.provincia,
        cityCode: provinciaObj?.cod_dane || "",
        notes: formData.notas,
      };

      const { orderId: id, orden } = await submitOrder(customerData);
      setOrderId(id);
      setOrdenGuardada(orden);
      setPedidoExitoso(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      console.error("Error al procesar pedido:", error);
      setErrors((prev) => ({
        ...prev,
        general:
          "Error al procesar el pedido. Por favor escríbenos por WhatsApp.",
      }));
    } finally {
      setLoading(false);
    }
  };

  // ── Carrito vacío ──
  if (cartItems.length === 0 && !pedidoExitoso) {
    return (
      <div className="checkout-vacio">
        <h2>Tu carrito está vacío</h2>
        <p>Agrega productos antes de proceder al checkout</p>
        <button onClick={() => navigate("/catalogo")}>Ir al Catálogo</button>
      </div>
    );
  }

  // ── Pedido exitoso ──
  if (pedidoExitoso) {
    const linkWA = ordenGuardada
      ? generarLinkWhatsApp(ordenGuardada)
      : buildWhatsAppUrl();

    return (
      <div className="pedido-exitoso-page">
        <div className="exito-card">
          <div className="check-icon">✓</div>
          <h1>¡Pedido Confirmado!</h1>
          <p className="numero-pedido">
            Número de orden: <strong>#{orderId}</strong>
          </p>

          <div className="detalles-entrega">
            <h3>📍 Datos de entrega</h3>
            <p>
              <strong>Nombre:</strong> {formData.nombre} {formData.apellido}
            </p>
            <p>
              <strong>Teléfono:</strong> {formData.telefono}
            </p>
            <p>
              <strong>Dirección:</strong> {formData.direccion}
            </p>
            <p>
              <strong>Ciudad:</strong> {formData.ciudad}, {formData.provincia}
            </p>
          </div>

          <div className="info-envio">
            <h3>🚚 ¿Qué sigue?</h3>
            <p>✅ Pagas en efectivo cuando recibes el producto.</p>
            <p>✅ Entrega estimada: 2-5 días hábiles.</p>
            <p>
              ✅ Te contactaremos al <strong>{formData.telefono}</strong> para
              coordinar.
            </p>
          </div>

          {/* ── Botón WhatsApp prellenado ── */}
          <div style={{ margin: "24px 0 16px" }}>
            <p
              style={{
                color: "#555",
                fontSize: "0.88rem",
                marginBottom: 10,
                textAlign: "center",
              }}
            >
              📋 Envíanos los detalles de tu pedido por WhatsApp para
              confirmarlo más rápido:
            </p>
            <a
              href={linkWA}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                background: "#25D366",
                color: "#fff",
                padding: "16px 20px",
                borderRadius: 12,
                fontWeight: 900,
                fontSize: "1rem",
                textDecoration: "none",
                boxShadow: "0 4px 16px rgba(37,211,102,0.4)",
                marginBottom: 8,
              }}
            >
              <svg width="22" height="22" viewBox="0 0 448 512" fill="white">
                <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
              </svg>
              💬 Confirmar pedido por WhatsApp
            </a>
            <p
              style={{
                color: "#aaa",
                fontSize: "0.75rem",
                textAlign: "center",
              }}
            >
              Se abre WhatsApp con todos los datos prellenados. Solo da clic en
              Enviar ✅
            </p>
          </div>

          <div className="acciones">
            <button onClick={() => navigate("/")}>Volver al inicio</button>
            <button onClick={() => navigate("/catalogo")}>
              Seguir comprando
            </button>
          </div>
        </div>
      </div>
    );
  }

  const total = getCartTotal();

  return (
    <div className="checkout-page">
      <style>{`
        .error-mensaje { color: #dc3545; font-size: 0.82em; margin-top: 4px; }
        .form-group input.error, .form-group select.error, .form-group textarea.error {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 3px rgba(220,53,69,.15);
        }
        .ciudad-disabled { background: #f5f5f5; color: #aaa; cursor: not-allowed; }

        @media (max-width: 768px) {
          /* Forzamos que los contenedores permitan el ancho total en móviles */
          .checkout-container, .checkout-izquierda {
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
          /* Mantenemos el espacio para el título y el formulario */
          .checkout-izquierda > h1, 
          .checkout-izquierda > form {
            padding-left: 16px !important;
            padding-right: 16px !important;
          }

          .aliados-container {
            margin: 40px 0 -20px 0 !important;
            width: 100% !important;
            padding: 0 !important;
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
          }
          .aliados-container img {
            border-radius: 0 !important;
            width: 100% !important;
            max-width: none !important;
            height: auto !important;
            display: block !important;
          }
          .aliados-container h2 {
            padding: 0 16px;
          }
        }
      `}</style>

      <div className="checkout-container">
        <div className="checkout-izquierda">
          <h1>Finalizar Pedido</h1>
          <form onSubmit={handleSubmit} noValidate>
            <div className="seccion-form">
              <h2>📱 Información de Contacto</h2>
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre *</label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    placeholder="Juan"
                    className={errors.nombre ? "error" : ""}
                  />
                  {errors.nombre && (
                    <div className="error-mensaje">{errors.nombre}</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Apellido *</label>
                  <input
                    type="text"
                    name="apellido"
                    value={formData.apellido}
                    onChange={handleInputChange}
                    placeholder="Pérez"
                    className={errors.apellido ? "error" : ""}
                  />
                  {errors.apellido && (
                    <div className="error-mensaje">{errors.apellido}</div>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Teléfono / WhatsApp *</label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    placeholder="0999999999"
                    className={errors.telefono ? "error" : ""}
                  />
                  {errors.telefono && (
                    <div className="error-mensaje">{errors.telefono}</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Email (Opcional)</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="correo@ejemplo.com"
                  />
                </div>
              </div>
            </div>

            <div className="seccion-form">
              <h2>📍 Dirección de Entrega</h2>
              <div className="form-group">
                <label>Provincia *</label>
                <select
                  name="provincia"
                  value={formData.provincia}
                  onChange={handleInputChange}
                  className={errors.provincia ? "error" : ""}
                >
                  <option value="">Selecciona tu provincia...</option>
                  {ECUADOR.map((p) => (
                    <option key={p.cod_dane} value={p.provincia}>
                      {p.provincia}
                    </option>
                  ))}
                </select>
                {errors.provincia && (
                  <div className="error-mensaje">{errors.provincia}</div>
                )}
              </div>

              <div className="form-group">
                <label>Ciudad *</label>
                <select
                  name="ciudad"
                  value={formData.ciudad}
                  onChange={handleInputChange}
                  disabled={!formData.provincia}
                  className={`${errors.ciudad ? "error" : ""} ${!formData.provincia ? "ciudad-disabled" : ""}`}
                >
                  <option value="">
                    {formData.provincia
                      ? "Selecciona tu ciudad..."
                      : "Primero selecciona una provincia"}
                  </option>
                  {ciudadesDisponibles.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
                {errors.ciudad && (
                  <div className="error-mensaje">{errors.ciudad}</div>
                )}
              </div>

              <div className="form-group">
                <label>Dirección Completa *</label>
                <input
                  type="text"
                  name="direccion"
                  value={formData.direccion}
                  onChange={handleInputChange}
                  placeholder="Av. Principal 123 y Calle Secundaria"
                  className={errors.direccion ? "error" : ""}
                />
                {errors.direccion && (
                  <div className="error-mensaje">{errors.direccion}</div>
                )}
              </div>

              <div className="form-group">
                <label>Referencia (Opcional)</label>
                <input
                  type="text"
                  name="referencia"
                  value={formData.referencia}
                  onChange={handleInputChange}
                  placeholder="Casa azul, frente al parque..."
                />
              </div>
            </div>

            <div className="seccion-form">
              <h2>📝 Notas Adicionales (Opcional)</h2>
              <textarea
                name="notas"
                value={formData.notas}
                onChange={handleInputChange}
                placeholder="Instrucciones especiales de entrega..."
                rows="3"
              />
            </div>

            <div className="seccion-form metodo-pago">
              <h2>💵 Método de Pago</h2>
              <div className="pago-cod">
                <input type="radio" checked readOnly />
                <label>
                  <strong>Pago Contra Entrega</strong>
                  <p>Pagarás en efectivo cuando recibas tu producto.</p>
                </label>
              </div>
            </div>

            {errors.general && (
              <div className="alert alert-danger text-center mb-3">
                {errors.general}
              </div>
            )}

            <button
              type="submit"
              className="btn-confirmar-pedido"
              disabled={loading}
            >
              {loading ? "⏳ Procesando..." : "✅ CONFIRMAR MI COMPRA"}
            </button>

            <p className="texto-legal">
              Al confirmar tu pedido, aceptas nuestros términos y condiciones.
            </p>
          </form>

          <div className="seccion-form mt-5 aliados-container">
            <h2 className="fs-5 text-center mb-3">
              Nuestros Aliados en Entregas
            </h2>
            <img
              src="https://i.imgur.com/bk1DAl0.png"
              alt="Aliados logísticos"
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          </div>
        </div>

        <div className="checkout-derecha">
          <div className="resumen-pedido">
            <h2>Resumen del Pedido</h2>
            <div className="productos-resumen">
              {cartItems.map((item) => (
                <div key={item.id} className="item-resumen">
                  <img
                    src={
                      item.imagenes?.[0] ||
                      item.imagen ||
                      item.images?.[0]?.url ||
                      "https://via.placeholder.com/80"
                    }
                    alt={item.nombre || item.title}
                  />
                  <div className="item-info w-100">
                    <div className="d-flex justify-content-between">
                      <h4>{item.nombre || item.title}</h4>
                      <button
                        type="button"
                        className="btn btn-link text-danger p-0"
                        onClick={() => removeFromCart(item.id)}
                      >
                        ✕
                      </button>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div className="d-flex align-items-center border rounded bg-white">
                        <button
                          type="button"
                          className="btn btn-sm px-2"
                          onClick={() =>
                            updateQuantity(item.id, item.quantity - 1)
                          }
                          disabled={item.quantity <= 1}
                        >
                          −
                        </button>
                        <span className="mx-2 fw-bold">{item.quantity}</span>
                        <button
                          type="button"
                          className="btn btn-sm px-2"
                          onClick={() =>
                            updateQuantity(item.id, item.quantity + 1)
                          }
                        >
                          +
                        </button>
                      </div>
                      <p className="item-precio mb-0">
                        $
                        {(
                          parseFloat(item.precio || item.price || 0) *
                          item.quantity
                        ).toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="totales">
              <div className="linea-total">
                <span>Subtotal:</span>
                <span>${total.toFixed(2)}</span>
              </div>
              <div className="linea-total">
                <span>Envío:</span>
                <span className="gratis">GRATIS 🎉</span>
              </div>
              <div className="linea-total total-final">
                <span>Total a pagar:</span>
                <span>${total.toFixed(2)} USD</span>
              </div>
            </div>

            <div className="garantias-checkout">
              <p>✅ Envío con nuestros aliados logísticos</p>
              <p>✅ Entrega en 2-5 días hábiles</p>
              <p>✅ Pago al recibir</p>
              <p>✅ Producto garantizado</p>
            </div>

            <button
              className="btn-vaciar-carrito"
              onClick={() => setShowModal(true)}
            >
              🗑️ Vaciar Carrito
            </button>
            <button
              className="btn-seguir-comprando"
              onClick={() => navigate("/catalogo")}
            >
              ← Seguir Comprando
            </button>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar acción</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que deseas vaciar el carrito?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              clearCart();
              setShowModal(false);
            }}
          >
            Sí, vaciar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Carrito;
